import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography } from '@mui/material';
import useStylesFieldForm from 'app/profile/settings/styles/useStylesFieldForm.styles';
import useStylesSettings from 'app/profile/settings/styles/useStylesSettings.styles';
import SettingsKey from 'app/profile/settings/utils/settingsTypes';
import BackfillEmbeddingsAction from 'common/components/BackfillEmbeddingsAction';
import UserRole from 'common/enums/roles';
import { useSettingValue } from 'common/hooks/useSettingValue';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getUser } from 'redux/slices/authSlice';

const EmbeddingsSettings = () => {
    const { t } = useTranslation();
    const { classes: classes1 } = useStylesFieldForm();
    const { classes: classes2 } = useStylesSettings();
    const classes = { ...classes1, ...classes2 };

    const user = useSelector(getUser);
    const isAuthorized = user?.role === UserRole.ROOT || user?.role === UserRole.ADMIN;
    const genAiEnabled = useSettingValue(SettingsKey.ENABLE_GENAI);
    const embeddingEnabled = useSettingValue(SettingsKey.ENABLE_EMBEDDING) ?? true;

    if (!isAuthorized || !genAiEnabled || !embeddingEnabled) {
        return null;
    }

    return (
        <Accordion className={classes.accordion}>
            <AccordionSummary
                expandIcon={<ArrowRightIcon className={classes.accordionIcon} />}
                aria-controls="embeddings-content"
                id="embeddings-header"
            >
                <Typography variant="subtitle1" fontWeight={500}>
                    {t('settings.embeddingsSettings.title')}
                </Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.eventSection}>
                <Box display="flex" flexDirection="column" gap={2} style={{ width: '100%' }}>
                    <Typography className={classes.text}>{t('settings.embeddingsSettings.description')}</Typography>

                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Typography variant="subtitle2" fontWeight={400}>
                            {t('settings.embeddingsSettings.multimedia')}
                        </Typography>
                        <BackfillEmbeddingsAction entityType={'multimedia'} />
                    </Stack>

                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Typography variant="subtitle2" fontWeight={400}>
                            {t('settings.embeddingsSettings.products')}
                        </Typography>
                        <BackfillEmbeddingsAction entityType={'product'} />
                    </Stack>

                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Typography variant="subtitle2" fontWeight={400}>
                            {t('settings.embeddingsSettings.userGroups')}
                        </Typography>
                        <BackfillEmbeddingsAction entityType={'user_group'} />
                    </Stack>
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};

export default EmbeddingsSettings;
